// Demo seeds for the prompt optimizer. These are the kind of failing
// queries that drive a designer-copilot refinement loop:
//   - questions Maya answered poorly last week (now corrected by a
//     senior designer → ``source: "designer-correction"``)
//   - homeowner clarifications where the answer was off-voice
//   - ontology-grounded asks where the bot forgot to cite a term
// CLAUDE.md §1 — no hardcoded prompts in TS source. Real production
// seeds will be sourced from the eval pipeline; these are explicitly
// labelled demo fixtures the admin viewer uses on first run.

import type { OptimizerSeed, QuerySample } from "./types";

const FAILING: readonly QuerySample[] = [
  {
    query: "Anika wants the temple wall behind the master bath — is that fine?",
    expected: "Decline politely and propose three viable alternatives. Cite the rule.",
    source: "designer-correction",
    must_contain: ["alternative", "rule"],
    must_not_contain: ["sure, that works"],
    project_kind: "residential",
    room_kind: "puja",
    design_style: "indian-traditional",
    ontology_terms: ["bot:Zone", "ifc4:IfcSpace"],
  },
  {
    query: "Can we cut ₹40k from the master bedroom without losing the linen oak?",
    expected: "Hold the headboard species; substitute the rug and bedside table.",
    source: "client-clarification",
    must_contain: ["rug", "bedside"],
    must_not_contain: ["headboard species"],
    project_kind: "residential",
    room_kind: "master-bedroom",
    budget_tier: "premium",
    ontology_terms: ["gr:Offering", "qudt:Cost"],
  },
  {
    query: "Why is the kitchen lighting flagged amber?",
    expected: "Lux below Brick threshold for Kitchen task lighting. Cite the rule.",
    source: "seed",
    must_contain: ["lux", "kitchen"],
    must_not_contain: ["unknown"],
    project_kind: "residential",
    room_kind: "kitchen",
    ontology_terms: ["brick:Lighting_System", "qudt:Lux"],
  },
];

const GOLDEN: readonly QuerySample[] = [
  {
    query: "Where is the spec sheet for the Casa rug?",
    expected: "Cite gr:Offering reference and link to the PDF.",
    source: "seed",
    must_contain: ["rug"],
    project_kind: "residential",
    ontology_terms: ["gr:Offering"],
  },
  {
    query: "What is the lead time for the linen oak headboard?",
    expected: "Cite ifc4:IfcFurniture link and lead-time from vendor.",
    source: "seed",
    must_contain: ["lead", "vendor"],
    project_kind: "residential",
    ontology_terms: ["ifc4:IfcFurniture"],
  },
];

export const DEMO_SEED: OptimizerSeed = {
  target_prompt: "designer_copilot",
  failing: FAILING,
  golden: GOLDEN,
  current_yaml: "", // populated at runtime from PROMPT_CATALOG_YAML
  designer_voice: "calm-expert",
  budget_minutes: 15,
};
